<template>
    <div id="loginMobile">
        <video class="video" v-if="!$store.state.cogir" muted autoplay loop webkit-playsinline playsinline>
            <source src="@/assets/video/background.mp4" type="video/mp4">
        </video>

      <video class="video" v-if="$store.state.cogir" muted autoplay loop webkit-playsinline playsinline>
        <source src="@/assets/video/background-cogir.mp4" type="video/mp4">
      </video>

        <div class="top">
          <div class="cogir-logo">
            <img v-if="$store.state.cogir" src="@/assets/img/logo-cogir.png">
          </div>

          <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">
          <img v-if="$store.state.cogir" src="@/assets/img/logo-octo-white.png">
        </div>

        <div class="page" v-show="show == 'intro'">
<!--            <div class="top">-->
<!--                <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">-->
<!--                <img v-if="$store.state.cogir" src="@/assets/img/logo-octo.png">-->
<!--            </div>-->
            <div class="buttons vertical">
                <div class="button" @click="setCurrentPage('login')">{{ $t("login.open_session") }}</div>
                <div class="button" @click="toNoAccount">{{ $t("login.no_account") }}</div>
            </div>
            <div class="bottom">
                <div class="forgot" @click="setCurrentPage('forgot')">{{ $t("login.forgot") }}</div>
                <div class="locale" @click="setLocale('en')" v-if="this.$ts.state.locale != 'en'">{{ $t("locale.en") }}</div>
                <div class="locale" @click="setLocale('fr')" v-if="this.$ts.state.locale == 'en'">{{ $t("locale.fr") }}</div>
            </div>
        </div>

        <div class="page" v-show="show == 'login'">
<!--            <div class="top">-->
<!--                <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">-->
<!--                <img v-if="$store.state.cogir" src="@/assets/img/logo-octo.png">-->
<!--            </div>-->
            <div class="form">
                    <input type="text" v-model="user.username">
                    <label>{{ $t("user.username") }}</label>
                    <input type="password" v-model="user.password" autocomplete="off">
                    <label>{{ $t("user.password") }}</label>
            </div>
            <div class="buttons">
                <div class="button" @click="setCurrentPage('intro')">{{ $t("navigation.back") }}</div>
                <div class="button" @click="login">{{ $t("login.connection") }}</div>
            </div>
            <div class="bottom">
                <div class="forgot" @click="setCurrentPage('forgot')">{{ $t("login.forgot") }}</div>
                <div class="locale" @click="setLocale('en')" v-if="this.$ts.state.locale != 'en'">{{ $t("locale.en") }}</div>
                <div class="locale" @click="setLocale('fr')" v-if="this.$ts.state.locale == 'en'">{{ $t("locale.fr") }}</div>
            </div>
        </div>

        <div class="page" v-show="show == 'forgot'">
<!--            <div class="top">-->
<!--                <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">-->
<!--                <img v-if="$store.state.cogir" src="@/assets/img/logo-octo.png">-->
<!--            </div>-->
            <div class="form">
                <p>{{ $t("login.reset_password_text") }}</p>
                <input type="text" v-model="user.emailForgot">
                <label>{{ $t("user.email") }}</label>
            </div>
            <div class="buttons">
                <div class="button" @click="resetPassword">{{ $t("login.reset_password") }}</div>
            </div>
            <div class="bottom" style="justify-content: center" @click="setCurrentPage('intro')">
                {{ $t("navigation.back") }}
            </div>
        </div>
    </div>
</template>

<script>
    import Configuration from "../../../core/Configuration";
    import moment from "moment";

    export default {

        name: "LoginMobile",

        props: {

            login: Function,
            toNoAccount: Function,
            resetPassword: Function,
            setCurrentPage: Function,

            user: Object,
            show: String

        },

        methods: {
            setLocale(locale) {
                this.$ts.commit("setLocale", locale);
                Configuration.write("locale", locale);
                moment.locale(locale);
            }
        }

    }
</script>

<style lang="scss" scoped>
    #loginMobile {
        height: 100%;
        padding: 0 50px 50px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .page {
        height: 100%;
        z-index: 1;
        flex-basis: 300px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
    .video {
        position: fixed;
        left: 50%;
        top: 0;
        height: 100%;
        transform: translateX(-50%);
        z-index: 0;
    }

    .top {
        flex-grow: 4;
        flex-basis: 250px;
        display: flex;
        align-items: flex-end;
        z-index: 1;
        img {
            width: 100%;
        }
    }

    input {
        width: 100%;
    }

    .form {
        z-index: 1;
        p {
            color: white;
            padding: 0 17px;
            text-align: center;
        }
    }

    .buttons {
        display: flex;
        margin-top: 10px;
        z-index: 1;
        flex-shrink: 0;
        &.vertical {
            display: block;
            .button {
                width: 100%;
                &:not(:last-of-type) {
                    margin-bottom: 10px;
                }
            }
        }
    }

    .button {
        height: 50px;
        font-size: 16px;
        color: white;
        border: 2px solid white;
        flex-grow: 1;
        flex-basis: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        &:not(:last-of-type) {
            margin-right: 20px;
        }
    }

    .bottom {
        font-size: 12px;
        z-index: 1;
        display: flex;
        margin-top: 24px;
        color: white;
        font-weight: 500;
        .forgot {
            flex-grow: 1;
        }
    }
    .btn {
        width: 400px;
    }
    .actions {
        display: flex;
        width: 400px;
        .btn {
            width: auto;
            flex-grow: 1;
            flex-basis: 0;
            &:not(:last-of-type) {
                margin-right: 20px;
            }
        }
    }
    .description {
        margin-bottom: 20px;
    }
</style>